(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nv-produktdaten"] && !Shopify.designMode) return;
  try {
    // Groessenkachel bei Artikeln mit mehreren Groessen (15.09.2026): Horizon laedt beim
  // Variantenwechsel nur den Variantenwaehler neu, nicht diesen Block. Die Kachel folgt der
  // Auswahl deshalb hier — sie traegt den Optionsnamen, und nur eine Auswahl in genau dieser
  // Option aendert sie.
  if (!window.nvGroessenKachel) {
    window.nvGroessenKachel = true;
    document.addEventListener('change', (e) => {
      const feld = e.target instanceof Element ? e.target.closest('variant-picker input[data-option-name], variant-picker select') : null;
      if (!feld) return;
      const auswahl = feld.tagName === 'SELECT' ? feld.selectedOptions[0] : feld;
      const name = auswahl?.dataset.optionName;
      const wert = auswahl?.value;
      if (!name || !wert) return;
      const bereich = feld.closest('.product-details') || document;
      bereich.querySelectorAll('[data-nv-groesse-option]').forEach((kachel) => {
        if (kachel.dataset.nvGroesseOption === name) kachel.textContent = wert;
      });
    });
  }

  // Fortschrittsbalken fuer die Empfehlungszeilen.
  //
  // Reines CSS reicht hier nicht: `animation-timeline: scroll()` waere elegant, laesst sich
  // aber nicht ueber Elementgrenzen hinweg auf ein Geschwister-Element anwenden, ohne
  // `timeline-scope` — und der Balken muss AUSSERHALB des Scrollbereichs liegen, sonst
  // wandert er mit dem Inhalt weg. Der native Scrollbalken faellt aus, weil er auf iOS nur
  // waehrend des Wischens sichtbar ist.
  //
  // Der Balken wird nur dort eingehaengt, wo tatsaechlich etwas zu scrollen ist.
  (() => {
    const einhaengen = () => {
      document.querySelectorAll('[class*="product-recommendations"]').forEach((abschnitt) => {
        abschnitt.querySelectorAll('slideshow-slides').forEach((spur) => {
          if (spur.dataset.nvBalken) return;
          if (spur.scrollWidth <= spur.clientWidth + 8) return;
          if (spur.closest('.product-card')) return; // die Galerien IN den Karten nicht

          spur.dataset.nvBalken = '1';
          const gleis = document.createElement('div');
          gleis.className = 'nv-fortschritt';
          const daumen = document.createElement('span');
          daumen.className = 'nv-fortschritt__daumen';
          gleis.appendChild(daumen);
          spur.insertAdjacentElement('afterend', gleis);

          const zeichnen = () => {
            const strecke = spur.scrollWidth - spur.clientWidth;
            const anteil = spur.clientWidth / spur.scrollWidth;
            const wo = strecke > 0 ? spur.scrollLeft / strecke : 0;
            // Formel korrigiert 17.09.2026 (gleicher Fehler wie im Kategorie-Indikator der Startseite):
            // `translateX(%)` bezieht sich auf die unskalierte Schiene, der Weg ist (1 − Anteil).
            // Das fruehere `/ anteil` schob den Balken 1/Anteil-mal zu weit und aus der Schiene.
            // Derzeit nicht im Einsatz (keine `product-recommendations` auf der Produktseite).
            daumen.style.transform =
              'translateX(' + (Math.min(1, Math.max(0, wo)) * (1 - anteil) * 100) + '%) scaleX(' + anteil + ')';
          };
          zeichnen();
          spur.addEventListener('scroll', zeichnen, { passive: true });
          new ResizeObserver(zeichnen).observe(spur);
        });
      });
    };

    // Die Empfehlungen werden asynchron nachgeladen — deshalb beobachten statt einmal laufen.
    einhaengen();
    new MutationObserver(einhaengen).observe(document.body, { childList: true, subtree: true });
  })();

  // ── AUS DEM HTML HIERHER VERSCHOBEN — 03.09.2026, Audit-Befund B4 ────────────────────
  // Dieser Block steckt DREIMAL in `templates/product.json` (Eckdaten, Datentabelle,
  // Kurztext). Beide Skripte standen unbedingt im Liquid-Koerper, wurden also dreimal ins
  // HTML geschrieben (gemessen: 11.721 + 3.999 Zeichen) und liefen dreimal — jedes mit
  // eigenen Zuhoerern und einem dokumentweiten Durchlauf.
  // `{% javascript %}` buendelt Shopify EINMAL je Blocktyp, unabhaengig von der Zahl der
  // Instanzen. Damit sind die Dopplung im HTML und die Mehrfachausfuehrung zugleich weg.
  // Gefahrlos, weil beide Skripte reines JavaScript ohne Liquid sind (geprueft) und beide
  // ihren Startpunkt bereits ueber `readyState` absichern statt blind auf ein Ereignis zu
  // warten — im Buendel ist der DOM naemlich in der Regel laengst fertig.

  (() => {
    /* Marke je Stichwort. Bewusst eine feste Liste statt einer Heuristik: Ein falsches
       Symbol ist schlimmer als gar keines. Unbekannte Stichwörter bleiben ohne Marke. */
    const P = {
      /* Qualität & Pflege */
      selection:  '<path d="M10 4.6a1.5 1.5 0 1 1 1.5 1.5c-.85 0-1.5.6-1.5 1.35v.6"/><path d="M10 8.05 3.4 12.6c-.75.5-.4 1.7.5 1.7h12.2c.9 0 1.25-1.2.5-1.7L10 8.05z"/>',
      cleaning:   '<path d="M10 3.2s4.6 4.7 4.6 7.5a4.6 4.6 0 1 1-9.2 0C5.4 7.9 10 3.2 10 3.2z"/>',
      condition:  '<circle cx="10" cy="10" r="6.8"/><path d="m6.9 10.2 2.2 2.2L13.3 8"/>',
      care:       '<path d="M3 7h14l-1 8.5a1.6 1.6 0 0 1-1.6 1.5H5.6A1.6 1.6 0 0 1 4 15.5z"/><path d="M3 7l3.2-3.2h7.6L17 7"/>',
      /* Größe & Maße */
      /* Dasselbe T-Shirt-Symbol unter zwei Stichworten: Die Zeile heisst seit dem
         08.09.2026 "The size we list" (die alte Fassung behauptete, wir naennten
         grundsaetzlich die Passform statt der Etikettengroesse). Der alte Schluessel bleibt
         stehen, damit aeltere Staende der Seite ihr Symbol behalten. */
      'every size is a fit': '<path d="M7.4 3.6 4 5.4l1.4 2.8 2-1V16h5.2V7.2l2 1L16 5.4l-3.4-1.8a2.7 2.7 0 0 1-5.2 0z"/>',
      'the size we list': '<path d="M7.4 3.6 4 5.4l1.4 2.8 2-1V16h5.2V7.2l2 1L16 5.4l-3.4-1.8a2.7 2.7 0 0 1-5.2 0z"/>',
      'the label': '<path d="M10.5 3H16v5.5L8.6 16 3 10.4z"/><circle cx="13.2" cy="6.2" r="1"/>',
      measurements: '<path d="M2.5 8h15v4h-15z"/><path d="M6 8v2M10 8v2.6M14 8v2"/>',
      'still unsure': '<circle cx="10" cy="10" r="7"/><path d="M8.2 8a1.9 1.9 0 1 1 2.6 1.8c-.5.2-.8.7-.8 1.2v.4"/><path d="M10 14.2v.01"/>',
      /* Versand & Rückgabe */
      dispatch: '<path d="M3 7.2 10 4l7 3.2v6L10 16.4 3 13.2z"/><path d="M3 7.2 10 10.4l7-3.2"/><path d="M10 10.4v6"/>',
      delivery: '<path d="M2.5 6h8v7h-8z"/><path d="M10.5 8.5H14l2.5 2.5V13h-6z"/><circle cx="5.5" cy="14.5" r="1.4"/><circle cx="13" cy="14.5" r="1.4"/>',
      tracking: '<path d="M2.8 5.5h14.4v9H2.8z"/><path d="m2.8 6 7.2 5 7.2-5"/>',
      returns:  '<path d="M4 10a6 6 0 1 1 1.9 4.4"/><path d="M3.2 6.6v3.6h3.6"/>',
    };
    /* Flaggen als flache SVG, gedaempfte Toene. Europa ist vorbereitet, falls spaeter eine
       eigene Zeile dazukommt; "weltweit" hat keine Flagge und bekommt einen Globus. */
    const FLAGGE = {
      germany: '<svg viewBox="0 0 18 12" aria-hidden="true"><rect width="18" height="4" fill="#1c1c1c"/><rect y="4" width="18" height="4" fill="#c1272d"/><rect y="8" width="18" height="4" fill="#e3bc3f"/></svg>',
      europe: '<svg viewBox="0 0 18 12" aria-hidden="true"><rect width="18" height="12" fill="#1f3a7a"/>'
        + Array.from({ length: 12 }, (_, i) => {
            const w = (i / 12) * Math.PI * 2;
            return '<circle cx="' + (9 + Math.sin(w) * 3.1).toFixed(2) + '" cy="' + (6 - Math.cos(w) * 3.1).toFixed(2) + '" r="0.62" fill="#e3bc3f"/>';
          }).join('') + '</svg>',
    };
    const GLOBUS = '<circle cx="10" cy="10" r="6.6"/><ellipse cx="10" cy="10" rx="2.9" ry="6.6"/><path d="M3.6 10h12.8"/>';
    const REGION = { international: GLOBUS, worldwide: GLOBUS };

    const marke = (wort) => {
      const k = wort.toLowerCase().replace(/[^a-z ]/g, '').trim();
      if (FLAGGE[k]) return '<span class="nv-marke nv-marke--flagge">' + FLAGGE[k] + '</span>';
      const d = REGION[k] || P[k];
      if (!d) return null;
      return '<span class="nv-marke"><svg viewBox="0 0 20 20" aria-hidden="true">' + d + '</svg></span>';
    };

    const setzen = () => {
      document.querySelectorAll('.product-details details.details p, .product-details details.details li')
        .forEach((el) => {
          if (el.dataset.nvMarke) return;
          const stark = el.querySelector('strong, b');
          if (!stark) return;
          const m = marke(stark.textContent || '');
          if (!m) { el.dataset.nvMarke = 'ohne'; return; }
          el.dataset.nvMarke = 'gesetzt';
          el.classList.add('nv-zeilenmarke');
          el.insertAdjacentHTML('afterbegin', m);
        });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setzen);
    else setzen();
    /* Horizon zeichnet die Produktdetails beim Variantenwechsel neu. */
    new MutationObserver(setzen).observe(document.documentElement, { childList: true, subtree: true });
  })();
  (() => {
    /* "About this piece" ist eine gewoehnliche Text-Ueberschrift aus den Blockeinstellungen
       und traegt keine eigene Klasse (geprueft: `.text-block` mit generiertem Klassennamen,
       der sich beim naechsten Speichern im Theme-Editor aendern kann — ein fester Selektor
       waere bruechig). Sie wird deshalb ueber ihre EIGENSCHAFTEN gefunden: kurze
       Ueberschrift, keine Verweise darin, hoechstens 18 px gross, noch nicht versal.
       Findet sich nichts, passiert nichts. */
    const angleichen = () => {
      document.querySelectorAll('.product-details .text-block, .product-details h2, .product-details h3')
        .forEach((e) => {
          const t = e.textContent.replace(/\s+/g, ' ').trim();
          if (!t || t.length > 34) return;
          if (e.querySelector('a, button, product-price, .price')) return;
          const c = getComputedStyle(e);
          if (parseFloat(c.fontSize) > 18) return;          /* Titel und Preis nicht anfassen */
          if (c.textTransform === 'uppercase') return;      /* steht schon in der Linie */
          e.classList.add('nv-gleiche-ueberschrift');
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', angleichen);
    else angleichen();
    /* Im Buendel kann `load` schon gefeuert haben, wenn dieser Code laeuft — dann
       wuerde ein blosser Zuhoerer nie greifen. Gleiche Behandlung wie oben. */
    if (document.readyState === 'complete') angleichen();
    else window.addEventListener('load', angleichen);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nv-versandzeile"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nv-versandzeile')) {
    /* Kurzformen, die weder der deutsche noch der englische Laendername enthaelt. */
    const NV_ALIASSE = {
      US: 'usa amerika america', GB: 'uk england grossbritannien great britain schottland scotland wales',
      NL: 'holland', AE: 'uae vae dubai emirate', CZ: 'tschechische republik czech republic',
      KR: 'korea', TR: 'turkey tuerkei', BA: 'bosnien bosnia', MK: 'mazedonien macedonia',
    };
    /* Kuerzere Anzeige, wo der amtliche Name in der Liste sperrig waere. */
    const NV_KURZNAMEN = { de: { US: 'USA' }, en: { US: 'USA' } };
    const nvNormal = (s) => String(s || '').toLocaleLowerCase()
      .replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    class NvVersandzeile extends HTMLElement {
      connectedCallback() {
        if (this.dataset.nvBereit) return;
        this.dataset.nvBereit = '1';
        this.sprache = this.dataset.sprache || document.documentElement.lang || 'de';
        this.tarife = new Map((this.dataset.tarife || '').split(',').filter(Boolean).map((e) => {
          const [land, ab, frei] = e.split(':');
          return [land, { ab: Number(ab), frei: frei ? Number(frei) : null }];
        }));
        this.knopf = this.querySelector('.nv-versandzeile__wahl');
        this.name = this.querySelector('.nv-versandzeile__landname');
        this.preis = this.querySelector('.nv-versandzeile__preis');
        this.label = this.querySelector('.nv-versandzeile__label');
        this.dialog = this.querySelector('.nv-versandwahl');
        this.suche = this.querySelector('.nv-versandwahl__suche');
        this.liste = this.querySelector('.nv-versandwahl__liste');
        if (!this.tarife.size || !this.knopf || !this.dialog) return;
        this.artikel = this.dataset.artikelpreisEur ? Number(this.dataset.artikelpreisEur) : null;

        const region = (lang) => { try { return new Intl.DisplayNames([lang], { type: 'region' }); } catch { return null; } };
        const hier = region(this.sprache), de = region('de'), en = region('en');
        const kurz = NV_KURZNAMEN[this.sprache] || {};
        this.laender = [...this.tarife.keys()].map((code) => {
          const name = kurz[code] || hier?.of(code) || code;
          return { code, name, suche: nvNormal([name, de?.of(code), en?.of(code), code, NV_ALIASSE[code]].join(' ')) };
        }).sort((a, b) => a.name.localeCompare(b.name, this.sprache));
        this.nachCode = new Map(this.laender.map((l) => [l.code, l]));
        this.haeufig = (this.dataset.haeufig || '').split(',').map((c) => c.trim().toUpperCase()).filter((c) => this.tarife.has(c));

        this.land = this.tarife.has(this.dataset.land) ? this.dataset.land : 'DE';
        this.gewaehlt = false;
        try {
          const gemerkt = localStorage.getItem('nv-versandland');
          if (gemerkt && this.tarife.has(gemerkt)) { this.land = gemerkt; this.gewaehlt = true; }
        } catch {}
        /* Ohne eigene Wahl: IP-Land statt Shop-Land — aber NUR, solange der Shop auf dem
           Standard „DE" steht. Genau dort landen EU-Besucher, die Shopify nicht umleitet.
           Steht er auf einem anderen Land, hat der Besucher es gewaehlt oder Shopify hat ihn
           umgeleitet; das gilt dann (gemessen 13.09.: Shop-Land CH, IP DE → zeigte „Germany"). */
        if (!this.gewaehlt && window.nvGeoLand && this.dataset.land === 'DE') {
          const geo = window.nvGeoLand.bekannt();
          if (geo && this.tarife.has(geo)) this.land = geo;
          else if (!geo) {
            window.nvGeoLand.erkennen().then((land) => {
              if (land && this.tarife.has(land) && !this.gewaehlt && land !== this.land) {
                this.land = land;
                this.zeigen();
              }
            });
          }
        }

        this.knopf.addEventListener('click', () => this.oeffnen());
        this.querySelector('.nv-versandwahl__zu').addEventListener('click', () => this.dialog.close());
        /* Klick auf den abgedunkelten Hintergrund trifft das <dialog> selbst. */
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => this.knopf.setAttribute('aria-expanded', 'false'));
        this.suche.addEventListener('input', () => this.fuellen());
        this.suche.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          this.liste.querySelector('button[data-land]')?.click();
        });
        this.liste.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-land]');
          if (b) this.waehlen(b.dataset.land);
        });
        this.zeigen();
      }

      /* Im Format des Shops (Admin → Waehrungsformat), wie `money_without_trailing_zeros` in Liquid:
         ganze Betraege ohne Nachkommastellen. So stehen Preis und Versandzeile immer gleich da. */
      geld(betrag) {
        const [e, c] = Number(betrag).toFixed(2).split('.');
        const ganz = c === '00';
        const tausend = (z, sep) => z.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        const muster = this.dataset.geldMuster || '{{amount_with_comma_separator}} €';
        /* Enthält das Admin-Format ein geschütztes Leerzeichen (`&nbsp;`), kommt es hier als Text an. */
        return muster
          .replace(/&nbsp;/g, '\u00a0')
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, tausend(e, '.'))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, tausend(e, '.') + (ganz ? '' : ',' + c))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, tausend(e, ','))
          .replace(/\{\{\s*amount\s*\}\}/, tausend(e, ',') + (ganz ? '' : '.' + c));
      }

      oeffnen() {
        this.suche.value = '';
        this.fuellen();
        this.dialog.showModal();
        this.knopf.setAttribute('aria-expanded', 'true');
        /* Tastatur nur am Rechner sofort aktiv — auf dem Handy wuerde sie die Liste verdecken. */
        if (window.matchMedia('(pointer: fine)').matches) this.suche.focus();
        else this.liste.scrollTop = 0;
      }

      zeile(l) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'nv-versandwahl__land';
        b.dataset.land = l.code;
        if (l.code === this.land) b.setAttribute('aria-current', 'true');
        const n = document.createElement('span');
        n.textContent = l.name;
        const p = document.createElement('span');
        p.className = 'nv-versandwahl__preis';
        p.textContent = this.dataset.textAbKurz.replace('[preis]', this.geld(this.tarife.get(l.code).ab));
        b.append(n, p);
        return b;
      }

      fuellen() {
        const q = nvNormal(this.suche.value.trim());
        const teile = [];
        if (!q) {
          const codes = [...new Set([this.land, ...this.haeufig])];
          const kopf = document.createElement('p');
          kopf.className = 'nv-versandwahl__gruppe';
          kopf.textContent = this.dataset.textHaeufig;
          teile.push(kopf, ...codes.map((c) => this.nachCode.get(c)).filter(Boolean).map((l) => this.zeile(l)));
        } else {
          const treffer = this.laender.filter((l) => l.suche.includes(q));
          /* Wer „sch" tippt, sucht eher Schweiz als Tschechien: Wortanfaenge zuerst. */
          const beginnt = (l) => l.suche.split(' ').some((w) => w.startsWith(q));
          treffer.sort((a, b) => Number(beginnt(b)) - Number(beginnt(a)));
          if (treffer.length) teile.push(...treffer.map((l) => this.zeile(l)));
          else {
            const leer = document.createElement('p');
            leer.className = 'nv-versandwahl__leer';
            leer.textContent = this.dataset.textKeine;
            teile.push(leer);
          }
        }
        this.liste.replaceChildren(...teile);
      }

      waehlen(code) {
        this.land = code;
        this.gewaehlt = true;
        try { localStorage.setItem('nv-versandland', code); } catch {}
        this.zeigen();
        this.dialog.close();
        this.knopf.focus();
      }

      zeigen() {
        const t = this.tarife.get(this.land);
        if (!t) return;
        this.name.textContent = this.nachCode.get(this.land)?.name || this.land;
        const frei = t.frei !== null && this.artikel !== null && this.artikel >= t.frei;
        if (this.label) this.label.textContent = frei ? this.dataset.textVersandFrei : this.dataset.textVersand;
        this.preis.textContent = frei ? '' : this.dataset.textAbKurz.replace('[preis]', this.geld(t.ab));
      }
    }
    customElements.define('nv-versandzeile', NvVersandzeile);
  }
  } catch(e) { console.error(e); }
})();

})();
